import conversionUtcDate from 'src/utils/conversionUtcDate'
import { getGcloudAll } from '/src/@api/dashboard'
import { createDeviceScopedChatSlice } from 'src/store/apps/createDeviceScopedChatSlice'
import { buildTimeParams } from 'src/utils/dateRangeParams'

const readDeviceSnapshot = () => ({
  deviceUser: JSON.parse(localStorage.getItem('DeviceUser') || '{}'),
  currentDevice: JSON.parse(localStorage.getItem('currentDevice') || '{}')
})

const mapDetail = item => ({
  ...item,
  time: conversionUtcDate(item.date, 'UTC', 'YYYY-MM-DD HH:mm'),
  defaultAvata: '/images/avatars/10.png'
})

const loadSummary = async ({ page, range }) => {
  const { deviceUser, currentDevice } = readDeviceSnapshot()
  const username = deviceUser?.username || ''
  const deviceUdid = currentDevice?.id || ''
  const response = await getGcloudAll({
    username,
    params: {
      category: 'SMS_SUMMARY',
      offset: (page - 1) * 200,
      limit: 200,
      deviceUdid,
      // 日期筛选走接口：带 startTime/endTime 时服务端按时间过滤
      ...buildTimeParams(range)
    }
  })
  const data = response.data.contents?.map(item => ({
    ...item,
    chatid: item.displayName,
    time: conversionUtcDate(item.snippetTimestamp, 'UTC', 'YYYY-MM-DD'),
    defaultAvata: '/images/avatars/10.png'
  })) || []
  let defaultSelectData = []
  if (page === 1 && data[0]) {
    const detail = await getGcloudAll({
      username,
      params: {
        category: 'SMS_DETAIL',
        offset: 0,
        limit: 50,
        deviceUdid,
        rid: data[0].guid,
        ...buildTimeParams(range)
      }
    })
    defaultSelectData = detail.data.contents?.map(mapDetail) || []
  }

  return { data, defaultSelectData, leftTotalCount: response.data.totalCount }
}

const loadDetail = async ({ contact, page, range }) => {
  const { deviceUser, currentDevice } = readDeviceSnapshot()
  const response = await getGcloudAll({
    username: deviceUser?.username || '',
    params: {
      category: 'SMS_DETAIL',
      offset: (page - 1) * 50,
      limit: 50,
      rid: contact.guid,
      deviceUdid: currentDevice?.id || '',
      ...buildTimeParams(range)
    }
  })

  return {
    selected: response.data.contents?.map(item => ({ ...mapDetail(item), defaultAvata: '/images/avatars/11.png' })) || [],
    rightTotalCount: response.data.totalCount
  }
}

const chat = createDeviceScopedChatSlice({
  sliceName: 'AndroidTextMessages',
  storeKey: 'androidTextMessage',
  actionPrefix: 'androidTextMessages',
  contactKey: 'guid',
  storageKey: 'smsItem',
  loadSummary,
  loadDetail,
  createExtraState: () => ({ fetchLoading: false })
})

export const fetchUserProfile = chat.fetchSummary
export const selectMessage = chat.selectDetail
export const removeSelectedChat = chat.removeSelectedChat
export const setMessageDateRange = chat.setDateRange
export default chat.reducer
